import { css } from '@emotion/react'
import { mdiCrown } from '@mdi/js'
import Icon from '@mdi/react'
import React from 'react'
import i18n from '../../utilities/i18n'

const bottomMargin = css({ marginBottom: 0 })

const Crown = (props) => (
    <Icon
        path={mdiCrown}
        css={bottomMargin}
        title={i18n.t('settings.pinToTop.priorWinnersTooltip')}
        size={0.8}
        {...props}
    />
)

export default React.memo(Crown)
